export { getBridgeRoot, initBridgeRoot } from './bridge-root.js';
